import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=7faf9d11&scoped=true&"
import script from "./Homepage.vue?vue&type=script&lang=js&"
export * from "./Homepage.vue?vue&type=script&lang=js&"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=7faf9d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf9d11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7faf9d11')) {
      api.createRecord('7faf9d11', component.options)
    } else {
      api.reload('7faf9d11', component.options)
    }
    module.hot.accept("./Homepage.vue?vue&type=template&id=7faf9d11&scoped=true&", function () {
      api.rerender('7faf9d11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/dashboard/Homepage.vue"
export default component.exports